import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackingComponent } from './tracking.component';

const routes: Routes = [{
  path: 'list', component: TrackingComponent,  pathMatch : 'full'
},
{ path: '**', redirectTo : 'list' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrackingRoutingModule { }
